// const object to get country name from countryCode iso 2 chars
// Each country written in its own language
export const COUNTRY_NAME_BY_CODE: { [key: string]: string } = {
  US: 'United States',
  ES: 'España',
  FR: 'France',
  IT: 'Italia',
  DE: 'Deutschland',
  PT: 'Portugal',
  GB: 'United Kingdom',
  CN: '中国',
  JP: '日本',
  RU: 'Россия',
}

// function to get country name from countryCode iso 2 chars
export const getCountryNameByCountryCode = (code: string): string => {
  if(COUNTRY_NAME_BY_CODE[code] === undefined) {
    console.warn(`Country code "${code}" not found in COUNTRY_NAME_BY_CODE constant.`)
  }

  return COUNTRY_NAME_BY_CODE[code] || ''
}
